import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { message, Form, Row, Col, Button } from 'antd'
import { useHistory } from 'react-router-dom'
import { makeStyles, Theme } from '@material-ui/core/styles'
import LogoImg from '@/assets/svg/logo.svg'
import imgLogin from '@/assets/img/img-login.svg'
import { InputField, InputPassword } from '@/components/FormElement'
import { useAppSelector } from '@/redux/store'
import LoadingSpinner from '@/components/Spinners/LoadingSpinner'
import { useForm } from 'react-hook-form'
import { loading, getUserDetails, loginToken } from '@/views/NewLogin/ducks/actions'
import { login } from '@/views/NewLogin/ducks/services'

const useStyles = makeStyles((theme: Theme) => ({
  loginPage: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
  },
  card: {
    margin: theme.spacing(12.5, 0, 0),
    maxWidth: 430,
    width: '100%',
    boxShadow: '0 0 16px rgba(27, 28, 29, 0.12)',
    borderRadius: 16,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logoWrapper: {
    margin: theme.spacing(4, 0, 5.875),
    maxWidth: 200,
    width: 120,
    height: 78,
  },
  logo: {
    width: '100%',
  },
  form: {
    width: '100%',
    maxWidth: 300,
  },
  btn: {
    fontSize: 16,
    margin: theme.spacing(5, 0, 3.5),
    padding: theme.spacing(1.375, 2),
  },
  field: {
    marginBottom: 10,
    '& .MuiInputBase-input': {
      padding: '14px 0 12px',
      fontSize: 14,
      '&::placeholder': {
        color: '#B9BBBD',
        opacity: 1,
      },
    },
  },
  label: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
    },
    '& .MuiIconButton-root': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  simpleLink: {
    color: '#7F8385',
    fontWeight: 500,
    margin: theme.spacing(2.625, 0, 14),
    '&:hover': {
      color: '#474A4B',
      textDecoration: 'none',
    },
  },
}))

export default (props: any) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const authState = useAppSelector((state) => state?.authenticationNew)

  const onSubmit = (val: { email: string; password: string }) => {
    dispatch(loading(true))
    login(val)
      .then((res) => {
        if (res) {
          dispatch(loginToken(res?.data?.token))
          localStorage.setItem('@maitretoken', JSON.stringify(res?.data?.token))
          // dispatch(loading(false))
          dispatch(getUserDetails())
        }
      })
      .catch((e) => {
        message.error({
          content: e?.response?.data?.error?.message ?? 'Something went wrong',
        })
        dispatch(loading(false))
      })
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { email: '', password: '' },
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  })

  useEffect(() => {
    dispatch(loading(false))
  }, [dispatch])

  console.log('v:1.1.6')

  return (
    <div className="login_new_page">
      <div className="login_left">
        <div className="login_left_wrapper">
          <div className="login_center">
            <div className="login_logo">
              <img src={LogoImg} alt="Logo" />
            </div>
            <div className="welcome_head">Welcome to Maitre</div>
            <div className="welcome_text">Please, enter your credentials to get started</div>
            <div className="login_sep" />
            <Form onFinish={handleSubmit(onSubmit)} className="login_form" layout="vertical">
              <Row>
                <Col span={24} className="email_field">
                  <InputField
                    fieldname="email"
                    label="Email"
                    control={control}
                    initValue=""
                    iProps={{
                      placeholder: 'Enter your account email',
                    }}
                    isRequired
                    rules={{
                      required: 'Enter your account email',
                      pattern: {
                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: 'Incorrect email address.',
                      },
                    }}
                    validate={errors.email && 'error'}
                    validMessage={errors.email && errors.email.message}
                  />
                </Col>

                <Col span={24}>
                  <InputPassword
                    fieldname="password"
                    label="Password"
                    control={control}
                    initValue=""
                    iProps={{
                      placeholder: 'Enter password',
                    }}
                    isRequired
                    rules={{
                      required: 'Enter password',
                      pattern: {
                        value: /^(?=.*[a-zа-яґєіїў])(?=.*[A-ZА-ЯҐЄІЇЎ])(?=.*\d).{8,20}$/,
                        message:
                          'The password must be 8 to 20 characters long, with at least one uppercase, one lowercase letter and one number.',
                      },
                    }}
                    validate={errors.password && 'error'}
                    validMessage={errors.password && errors.password.message}
                  />
                </Col>

                <Col span={24}>
                  <a href="/forgot-password" className="forgot_link">
                    I forgot my password
                  </a>
                </Col>

                <Col span={24}>
                  <Button htmlType="submit" disabled={authState.auth.loading} className="login_btn">
                    Sign In
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
      <div className="login_right">
        <div className="login_right_wrapper">
          <img src={imgLogin} alt="login" />
        </div>
      </div>

      {authState?.auth?.loading && (
        <div className="full_layout_loader">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}
